var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#111827",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 26,
    width: 59,
    height: 3,
    rx: 1.5,
    fill: "#fff2e6",
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 24,
    height: 14,
    rx: 2,
    fill: "#eaf6ff",
    stroke: "#0b1220"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 9,
    width: 6,
    height: 7,
    rx: 1,
    fill: "#9ad0b9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 9,
    width: 6,
    height: 7,
    rx: 1,
    fill: "#bde0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 20h4v3h-4z",
    fill: "#f6f8fa",
    stroke: "#0b1220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 29v23",
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 29v23",
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 31,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#ffd58b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 31,
    width: 15,
    height: 12,
    rx: 2,
    fill: "#ffd58b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 36,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#e0a55a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#e0a55a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskIcon);
export default __webpack_public_path__ + "static/media/desk-icon.23c91bd146ca3c61dd3427859020fab4.svg";
export { ForwardRef as ReactComponent };